<template lang="pug">

.blobs
  .blobs-intro.u-section-full.u-section-padding
    .grid.is-middle
      .column.u-mb-sm.is-widescreen-4.is-desktop-6
        h1.u-mb-xm {{$t('pageTitle')}}
        h5.u-mb-xs {{$t('mantra')}}
        p.u-mb-xm {{$t('mantraDesc')}}
        img.u-mb-xm(src='https://cdn.baianat.com/static/resources/blobs/1.png', srcset='https://cdn.baianat.com/static/resources/blobs/1.png 1x, https://cdn.baianat.com/static/resources/blobs/1@2x.png 2x')
        AppLink(to="https://baianat.com/files/file3n1sbi1jr653von" class="button is-rounded is-wide is-white" :title="$t('downloadIcons')") {{$t('downloadIcons')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/blobs/2.png', srcset='https://cdn.baianat.com/static/resources/blobs/2.png 1x, https://cdn.baianat.com/static/resources/blobs/2@2x.png 2x')

    .blobs-intro-shape(v-for="s in 3" :class="`is-${s}`")
      svg(xmlns='http://www.w3.org/2000/svg', width='548', height='209')
        path(fill-rule='evenodd', fill='#FFF', d='M534.281 144.773H225.047c-7.581 0-13.728-6.335-13.728-14.144 0-7.804 6.147-14.134 13.728-14.134h23.465c7.581 0 13.728-6.329 13.728-14.139 0-7.803-6.147-14.139-13.728-14.139H136.855c-7.581 0-13.728-6.33-13.728-14.139 0-7.804 6.147-14.133 13.728-14.133h314.722c7.581 0 13.729 6.329 13.729 14.133 0 7.809-6.148 14.139-13.729 14.139h-1.833c-7.581 0-13.729 6.336-13.729 14.139 0 7.81 6.148 14.139 13.729 14.139h84.537c7.581 0 13.727 6.33 13.727 14.134 0 7.809-6.146 14.144-13.727 14.144zM409.507 28.28H304.724c-7.58 0-13.726-6.33-13.726-14.139 0-7.804 6.146-14.133 13.726-14.133h104.783c7.58 0 13.728 6.329 13.728 14.133 0 7.809-6.148 14.139-13.728 14.139zM111.104 137.923h-.876c-3.627 0-6.564 3.183-6.564 7.096 0 3.92 2.937 7.091 6.564 7.091h40.407c3.625 0 6.557 3.178 6.557 7.103 0 3.914-2.932 7.091-6.557 7.091H48.705c-3.62 0-6.558-3.177-6.558-7.091 0-3.925 2.938-7.103 6.558-7.103h11.22c3.62 0 6.558-3.171 6.558-7.091 0-3.913-2.938-7.096-6.558-7.096H6.55c-3.62 0-6.559-3.172-6.559-7.091 0-3.914 2.939-7.092 6.559-7.092h104.554c3.627 0 6.559 3.178 6.559 7.092 0 3.919-2.932 7.091-6.559 7.091zm91.396 28.505h104.561c3.62 0 6.559 3.183 6.559 7.096 0 3.92-2.939 7.091-6.559 7.091h-.881c-3.62 0-6.559 3.184-6.559 7.097 0 3.919 2.939 7.091 6.559 7.091h40.406c3.633 0 6.558 3.177 6.558 7.103 0 3.913-2.925 7.091-6.558 7.091h-101.93c-3.62 0-6.559-3.178-6.559-7.091 0-3.926 2.939-7.103 6.559-7.103h11.22c3.62 0 6.559-3.172 6.559-7.091 0-3.913-2.939-7.097-6.559-7.097H202.5c-3.62 0-6.559-3.171-6.559-7.091 0-3.913 2.939-7.096 6.559-7.096z')


  section.u-mt-lg.u-textCenter
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        AppTitle.u-mb-xm(:title="$t('sharp')" tag="h2")

        .grid.is-widescreen-8.is-desktop-10.is-tablet-11.is-center
          .column
            p.u-mb-xm  {{$t('sharpDesc')}}
            h4.u-mb-xm  {{$t('mantra')}}
            img(src='https://cdn.baianat.com/static/resources/blobs/3.png', srcset='https://cdn.baianat.com/static/resources/blobs/3.png 1x, https://cdn.baianat.com/static/resources/blobs/3@2x.png 2x')


  section.blobs-multible.u-mt-lg.u-textCenter.u-section-full.u-section-padding
    h2.u-mb-xs {{$t('multiple')}}
    .grid.is-widescreen-6.is-desktop-8.is-tablet-10.is-center
      .column
        p.u-mb-xm  {{$t('multipleDesc')}}
    img(src='https://cdn.baianat.com/static/resources/blobs/4.png', srcset='https://cdn.baianat.com/static/resources/blobs/4.png 1x, https://cdn.baianat.com/static/resources/blobs/4@2x.png 2x')

  section.blobs-dark.u-textCenter.u-section-full.u-section-padding
    h2.u-mb-xs {{$t('darkBackground')}}

    .grid.is-widescreen-6.is-desktop-8.is-tablet-10.is-center
      .column
        p.u-mb-sm   {{$t('darkBackgroundDesc')}}
    img(src='https://cdn.baianat.com/static/resources/blobs/5.png', srcset='https://cdn.baianat.com/static/resources/blobs/5.png 1x, https://cdn.baianat.com/static/resources/blobs/5@2x.png 2x')

  section.blobs-colors.u-textCenter.u-section-full
    AppTitle.u-mb-xm(:title="$t('colorsPalettes')" tag="h2")

    img(src='https://cdn.baianat.com/static/resources/blobs/6.png', srcset='https://cdn.baianat.com/static/resources/blobs/6.png 1x, https://cdn.baianat.com/static/resources/blobs/6@2x.png 2x')


  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-middle
          .column.is-desktop-7.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/blobs/8.png', srcset='https://cdn.baianat.com/static/resources/blobs/8.png 1x, https://cdn.baianat.com/static/resources/blobs/8@2x.png 2x')
          .column.is-desktop-5.u-mb-sm
            h4 {{$t('easilyEditable')}}
            p {{$t('easilyEditableDesc')}}
          .column.is-desktop-5.u-mb-sm
            h4 {{$t('differentSizes')}}
            p {{$t('differentSizesDesc')}}
          .column.is-desktop-7.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/blobs/9.png', srcset='https://cdn.baianat.com/static/resources/blobs/9.png 1x, https://cdn.baianat.com/static/resources/blobs/9@2x.png 2x')


  section.blobs-green.u-textCenter.u-section-full
    img(src='https://cdn.baianat.com/static/resources/blobs/10.png', srcset='https://cdn.baianat.com/static/resources/blobs/10.png 1x, https://cdn.baianat.com/static/resources/blobs/10@2x.png 2x')

  section.u-textCenter.u-mt-lg
    img(src='https://cdn.baianat.com/static/resources/blobs/11.png', srcset='https://cdn.baianat.com/static/resources/blobs/11.png 1x, https://cdn.baianat.com/static/resources/blobs/11@2x.png 2x')

  section.blobs-free.u-section-full.u-section-padding
    h2  +1000
    p.u-text-lg.u-mb-lg {{$t('freeIcons')}}
    h4.u-mb-xm {{$t('whoBenifits')}}
    .grid.is-desktop-4
      .column.u-mb-sm
        h5 {{$t('designers')}}
        p {{$t('designersDesc')}}
      .column.u-mb-sm
        h5 {{$t('developers')}}
        p {{$t('developersDesc')}}
      .column.u-mb-sm
        h5 {{$t('details')}}
        p(v-for="item in $t('detailsItems')") {{item}}


    img(src='https://cdn.baianat.com/static/resources/blobs/12.png', srcset='https://cdn.baianat.com/static/resources/blobs/12.png 1x, https://cdn.baianat.com/static/resources/blobs/12@2x.png 2x')

  section.blobs-features.u-section-full.u-section-padding
    .grid.is-desktop-4
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/blobs/13.png', srcset='https://cdn.baianat.com/static/resources/blobs/13.png 1x, https://cdn.baianat.com/static/resources/blobs/13@2x.png 2x')
        h4.u-mh-xs {{$t('resizable')}}
        p {{$t('resizableDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/blobs/14.png', srcset='https://cdn.baianat.com/static/resources/blobs/14.png 1x, https://cdn.baianat.com/static/resources/blobs/14@2x.png 2x')
        h4.u-mh-xs {{$t('customizable')}}
        p {{$t('customizableDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/blobs/15.png', srcset='https://cdn.baianat.com/static/resources/blobs/15.png 1x, https://cdn.baianat.com/static/resources/blobs/15@2x.png 2x')
        h4.u-mh-xs {{$t('unlimitedColors')}}
        p {{$t('unlimitedColorsDesc')}}


  section.blobs-cta.u-section-full.u-section-padding.u-textCenter
    AppTitle.u-mb-xm(:title="$t('iconsSet')")

    p.u-mb-xm {{$t('enjoyBlobs')}}

    AppLink(to="https://baianat.com/files/file3n1sbi1jr653von" class="button is-rounded is-wide is-white" :title="$t('download')") {{$t('download')}}


</template>

<style lang="stylus">
$clMain = #ff3b30
$clBlue = #2476ff
$clDark = #142a3b
$clYellow = #fcb814
$clGreen = #0cb04a
$clDark2 = #122533

div.app.is-blobs
  overflow: hidden

  .header.is-scroll
    background: $clMain
    color: $clWhite !important

  .footer
    border-top: none

.blobs
  position: relative
  z-index: 1

  &-intro
    background: $clMain
    color: $clWhite
    padding-top: unitRes(240, 300)
    padding-bottom: unitRes(180, 200)
    z-index: 1
    position: relative
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)
    overflow: hidden

    &-shape
      position: absolute
      z-index: -1

      &.is-1
        right: -10vw
        top: 300px

        +mq($until: 'desktop')
          display: none

      &.is-2
        bottom: -110px
        left: 10vw

      &.is-3
        bottom: 600px
        left: -12vw
        transform: scale(0.6)

        +mq($until: 'tablet')
          display: none

  &-multible
    background: $clBlue
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)

  &-dark
    background: $clDark
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)

  &-colors
    background-color: $clYellow
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/blobs/7.png')
    background-attachment: fixed
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)
    background-position: center center

  &-green
    background-color: $clGreen
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/blobs/7.png')
    background-attachment: fixed
    padding-top: unitRes(100, 160)
    padding-bottom: unitRes(100, 160)
    background-position: center center

  &-free
    background-color: $clBlue
    color: $clWhite
    padding-top: unitRes(100, 160)
    padding-bottom: unitRes(100, 160)
    margin-top: -300px

    +mq($until: 'tablet')
      margin-top: 100px

  &-features
    background-color: $clYellow
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(50, 150)

  &-cta
    background: $clDark2
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,

  meta: {
    theme: 'is-blobs   is-whiteHeader is-fixedHeader',
    logoText: '__NONE__'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Blobs Icons",
    "pageDesc":"1000+ Free flat icons with two styles designed. Blobs was designed to give you variety of options and suit every industry. ",
    "mantra":"Colored with two styles",
    "mantraDesc":"Download 1000+ icons in vivid colors panel",
    "downloadIcons":"Download Icons",
    "sharp":"Sharp, lovable and |full of life.",
    "sharpDesc":"Enjoy a custom set of icons made to be highly customized. Change colors and sizes without having to worry about scalability issues. Add a unique look and feeling to your design and express more with less text.",
    "multiple":"Multiple use",
    "multipleDesc":"  Empowering you with +1000 flat icons in different categories to wove with your visual identity.",
    "darkBackground":"Dark background",
    "darkBackgroundDesc":"Blob icons look great on dark backgrounds.",
    "colorsPalettes":"Baianat colors |palettes",
    "easilyEditable":"Easily Editable",
    "easilyEditableDesc":"Easily edit blob icons; change colors and sizes to fit your designs.",
    "differentSizes":"Different Sizes",
    "differentSizesDesc":"No more scaling problems. Blob icons are available in three different sizes to fulfill all your design needs.",
    "freeIcons":"Free icons set",
    "whoBenifits":"Who benifits",
    "designers":"Designers",
    "designersDesc":"Enjoy Blobs icons on any platform you are using, PSD, AI, Sketch or even PNG.",
    "developers":"Developers",
    "developersDesc":"SVG icons format are made for you to serve and facilitate your work process.",
    "details":"Details",
    "detailsItems":{
      "1":"Type: Flat",
      "2":"Format: Ai - PSD - Sketsh - SVG",
      "3":"Count: 1000+",
      "4":"Size: 25 MB",
      "5":"Licence: Commercial"
    },
    "resizable":"Resizable",
    "resizableDesc":"To fulfill all your design needs, Blobs icons come to you in two different styles, colored and wired.",
    "customizable":"Customizable",
    "customizableDesc":"Enjoy Blobs icons as much as you want, as you can customize its colors or sizes to what suits you.",
    "unlimitedColors":"Unlimited Colors",
    "unlimitedColorsDesc":"If the color palette of the icons doesn't suit your works or designs, you can easily change its colors to what suits you.",
    "iconsSet":"Full free icons |set",
    "enjoyBlobs":"Enjoy the free set of all blobs flat icons",
    "download":"Download"
  },
  "ar": {
    "pageTitle":"أيقونات بلبس",
    "pageDesc":"1000+ من الأيقونات المسطحة المجانية مع اثنين من الأساليب. تم تصميم بلبس لإعطائك مجموعة متنوعة من الخيارات لتناسب كافة صناعة.",
    "mantra":"ملونة بأسلوبين متنوعين.",
    "mantraDesc":"حمل 1000+ من الأيقونات التي تتميز بلوحة ألوان زاهية.",
    "downloadIcons":"حمل الأيقونات",
    "sharp":"محبوبة ونابضة بالحياة.",
    "sharpDesc":"تمتع بمجموعة مُخصصة من الأيقونات حيث يمكنك تغيير الألوان والأحجام دون التفكير بشأن مشكلات قابلية التوسع. أضف مظهرًا وشعورًا فريدًا إلى تصميمك وعبر عن كل ما تريده من خلال نصوص أقل.",
    "multiple":"استخدامات متعددة",
    "multipleDesc":"تُمكّنك أيقونات بلبس من استخدام 1000+ أيقونة مسطحة في فئات مختلفة لتتماشى مع هويتك البصرية.",
    "darkBackground":"خلفيات داكنة",
    "darkBackgroundDesc":"تبدو أيقونات بلبس رائعة على الخلفيات الداكنة",
    "colorsPalettes":"لوحة ألوان |بيانات",
    "easilyEditable":"سهل التعديل عليها",
    "easilyEditableDesc":"يمكنك التعديل بسهولة على أيقونات بلبس، حيث يمكنك تغيير الألوان والأحجام بما يتناسب مع تصميمك.",
    "differentSizes":"أحجام مختلفة",
    "differentSizesDesc":"لن تعاني من مشكلات قابلية التوسع؛ لأن ايقونات بلبس متوفرة بثلاثة أحجام مختلفة لتلبية جميع احتياجات تصميمك.",
    "freeIcons":"أيقونة مجانية ",
    "whoBenifits":"لمْن تم تصميم بلبس؟!",
    "designers":"المصممون",
    "designersDesc":"حدث تصميمك الخاص مع الأيقونات التي تعمل في PSD أو AI أو Sketch أو حتى PNG.",
    "developers":"المبرمجون",
    "developersDesc":"تم تصميم الأيقونات SVG لتسهيل سير عملك وإنهائه في دقائق.",
    "details":"التفاصيل",
    "detailsItems":{
      "1":"النوع: مسطح",
      "2":"التنسيق: Ai - PSD - Sketch - SVG",
      "3":"العدد: 1000+",
      "4":"الحجم:25 MB",
      "5":"الترخيص: تجاري"
    },
    "resizable":"يمكن تغيير حجمها",
    "resizableDesc":"لتلبية جميع احتياجات تصميماتك، تأتي أيقونات بلبس بأسلوبين مختلفين، ملون وخطي.",
    "customizable":"مُخصصة",
    "customizableDesc":"استمتع بأيقونات بلبس حيث يمكنك تخصيص ألوانها أو أحجامها بما يناسبك.",
    "unlimitedColors":"ألوان لا نهائية",
    "unlimitedColorsDesc":"إذا كانت مجموعة الألوان لا تتماشى مع تصميمك، يمكنك بسهولة تغييرها إلى ما يناسبك.",
    "iconsSet":"أيقونات كاملة |مجانية ",
    "enjoyBlobs":"تمتع بمجموعة مجانية من أيقونات بلبس.",
    "download":"تحميل"
  }
}
</i18n>
